import * as React from "react";
import { memo } from "react";
const SvgStatusBackground = (props) => /* @__PURE__ */ React.createElement("svg", { width: 361, height: 56, viewBox: "0 0 361 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M360.5 8.89412L353.666 1.66644L4.79934 0L0.5 44.6644L12.326 56L353.666 52.8028L360.5 8.89412Z", fill: "#011022" }));
const Memo = memo(SvgStatusBackground);
export default Memo;
